















import { Component, Vue, Prop } from 'vue-property-decorator';
import VueJsonPretty from 'vue-json-pretty';
import EventError from '@/domain/event/event-error.entity';
import Event from '@/domain/event/event.entity';

@Component({
  components: {
    VueJsonPretty,
  },
})
export default class ContextViewer extends Vue {
  @Prop() context!: string;

  @Prop() date!: Date;

  get notEmpty() {
    return this.context.length > 0;
  }

  get json() {
    if (this.context) {
      return JSON.parse(this.context);
    }
    return '';
  }
}
